import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { FormGroupControl, FormGroupSelect } from '@components/Base';
import { FormValues } from './schema';

const GROUP_PROPS = { className: 'mb-3' };

const ClaimCardBody = () => {
  const { t } = useTranslation();
  const {
    values: { coveredByOtherInsurance, roomStay },
  } = useFormikContext<FormValues>();
  const isCoveredByOtherInsurance = (coveredByOtherInsurance as unknown as string) === 'true';
  const isRoomStay = (roomStay as unknown as string) === 'true';

  return (
    <Card.Body>
      <Card.Title>{t('healthInsuranceClaimForm.injuryOrIllnessSection.title')}</Card.Title>
      <Row>
        <Col>
          <FormGroupControl
            type="datetime-local"
            name="accidentHappenedAt"
            label={t('healthInsuranceClaimForm.injuryOrIllnessSection.accidentHappenedAt.label')}
            required
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            as="textarea"
            name="symptomsDescription"
            label={t('healthInsuranceClaimForm.injuryOrIllnessSection.symptomsDescription.label')}
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            as="textarea"
            name="diagnosisDescription"
            label={t('healthInsuranceClaimForm.injuryOrIllnessSection.diagnosisDescription.label')}
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupSelect
            name="coveredByOtherInsurance"
            label={t('healthInsuranceClaimForm.injuryOrIllnessSection.coveredByOtherInsurance.label')}
            groupProps={GROUP_PROPS}
            required
          >
            <option></option>
            <option value="true">{t('common:yes')}</option>
            <option value="false">{t('common:no')}</option>
          </FormGroupSelect>
        </Col>
      </Row>
      {isCoveredByOtherInsurance && (
        <Row>
          <Col>
            <FormGroupControl
              name="noteOnOtherInsurance"
              label={t('healthInsuranceClaimForm.injuryOrIllnessSection.noteOnOtherinsurance.label')}
              groupProps={GROUP_PROPS}
              required
            />
          </Col>
        </Row>
      )}
      <Row>
        <Col>
          <FormGroupSelect
            name="roomStay"
            label={t('healthInsuranceClaimForm.injuryOrIllnessSection.roomStay.label')}
            groupProps={GROUP_PROPS}
            required
          >
            <option></option>
            <option value="true">{t('common:yes')}</option>
            <option value="false">{t('common:no')}</option>
          </FormGroupSelect>
        </Col>
      </Row>
      {isRoomStay && (
        <>
          <Row>
            <Col>
              <FormGroupControl
                type="date"
                name="dischargeDate"
                label={t('healthInsuranceClaimForm.injuryOrIllnessSection.dischargeDate.label')}
                groupProps={GROUP_PROPS}
                required
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroupControl
                name="hospitalName"
                label={t('healthInsuranceClaimForm.injuryOrIllnessSection.hospitalName.label')}
                groupProps={GROUP_PROPS}
                required
              />
            </Col>
          </Row>
        </>
      )}
      <Row>
        <Col>
          <FormGroupControl
            required
            name="totalClaimedAmount"
            label={t('claimForm.totalClaimedAmount.label')}
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            required
            multiple
            type="file"
            name="medicalDocuments"
            label={t('healthInsuranceClaimForm.injuryOrIllnessSection.medicalDocuments.label')}
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroupControl
            required
            multiple
            type="file"
            name="identityDocuments"
            label={t('healthInsuranceClaimForm.injuryOrIllnessSection.identityDocuments.label')}
            groupProps={GROUP_PROPS}
          />
        </Col>
      </Row>
    </Card.Body>
  );
};

export { ClaimCardBody };
